<app-deprecated-modal-form
    #createBenefitDetailModal
    headerText="Add Coverage"
    [form]="benefitDetailCreateForm"
    (save)="onCreateBenefitDetail(benefitDetailCreateForm.benefitDetail)"
>
    <app-form-benefit-detail #benefitDetailCreateForm></app-form-benefit-detail>
</app-deprecated-modal-form>

<app-deprecated-modal-form
    #editBenefitDetailModal
    headerText="Edit Coverage"
    [form]="benefitDetailEditForm"
    (save)="onSaveBenefitDetail()"
    (cancel)="onCancelBenefitDetail(benefitDetailEditForm.benefitDetail)"
>
    <app-form-benefit-detail #benefitDetailEditForm></app-form-benefit-detail>
</app-deprecated-modal-form>

<app-deprecated-confirmation-dialog
    #deleteBenefitDetailConfirmationDialog
    [description]="'Are you sure you want to delete this coverage?'"
    [label]="'Delete Coverage'"
    [negative]="true"
>
</app-deprecated-confirmation-dialog>
<form class="ui form" #form="ngForm">
    <!-- Benefit Detail Without Type -->
    <div *ngFor="let detail of groupedBenefitDetails" class="benefit">
        <ng-container *ngIf="!detail.value[0]?.benefitType">
            <!-- Coverage Descriptions -->
            <div *ngFor="let coverage of detail.value" class="benefit-detail-description">
                <div class="benefit-description">{{ coverage.description }}</div>
            </div>
            <!-- Coverages -->
            <div *ngFor="let coverage of detail.value" class="benefit-details">
                <h4 class="ui header">
                    <i
                        class="fa fal fa-pencil editDetail"
                        (click)="
                            benefitDetailEditForm.setBenefit(benefit);
                            benefitDetailEditForm.setBenefitDetail(coverage);
                            editBenefitDetailModal.show()
                        "
                    ></i>
                    <i class="fa fal fa-times deleteDetail" (click)="onDeleteBenefitDetail(coverage)"></i>
                </h4>
                <div class="ui static form">
                    <div *ngIf="coverage.coverage" class="inline field">
                        <label>Coverage</label> {{ coverage.coverage }}%
                    </div>
                    <div *ngIf="coverage.reimbursement" class="inline field">
                        <label>Amount</label> {{ coverage.reimbursement | currency }}
                    </div>
                    <div *ngIf="coverage.deductible" class="inline field">
                        <label>Deductible</label> {{ coverage.deductible | currency }}
                    </div>
                    <div *ngIf="coverage.max" class="inline field">
                        <label>Maximum</label> {{ coverage.max | currency }}
                    </div>
                    <div *ngIf="coverage.nem" class="inline field">
                        <label>Non-evidence maximum</label> {{ coverage.nem | currency }}
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
    <!-- Benefit Details With Type -->
    <div *ngFor="let detail of groupedBenefitDetails" class="benefitWithType">
        <ng-container *ngIf="detail.value[0]?.benefitType">
            <h4 class="ui header">{{ detail.value[0].benefitType?.name }}</h4>
            <!-- Coverage Descriptions -->
            <div *ngFor="let coverage of detail.value" class="benefit-detail-description">
                <div class="benefit-description">{{ coverage.description }}</div>
            </div>
            <!-- Coverages -->
            <div *ngFor="let coverage of detail.value" class="benefit-details">
                <h4 class="ui header">
                    <i
                        class="fa fal fa-pencil editDetail"
                        (click)="
                            benefitDetailEditForm.setBenefit(benefit);
                            benefitDetailEditForm.setBenefitDetail(coverage);
                            editBenefitDetailModal.show()
                        "
                    ></i>
                    <i class="fa fal fa-times deleteDetail" (click)="onDeleteBenefitDetail(coverage)"></i>
                </h4>
                <div class="ui static form">
                    <div *ngIf="coverage.coverage" class="inline field">
                        <label>Coverage</label> {{ coverage.coverage }}%
                    </div>
                    <div *ngIf="coverage.reimbursement" class="inline field">
                        <label>Reimbursement</label> {{ coverage.reimbursement | currency }}
                    </div>
                    <div *ngIf="coverage.deductible" class="inline field">
                        <label>Deductible</label> {{ coverage.deductible | currency }}
                    </div>
                    <div *ngIf="coverage.max" class="inline field">
                        <label>Maximum</label> {{ coverage.max | currency }}
                    </div>
                    <div *ngIf="coverage.nem" class="inline field">
                        <label>Non-evidence maximum</label> {{ coverage.nem | currency }}
                    </div>
                </div>
            </div>
        </ng-container>
    </div>

    <a class="addDetail" (click)="benefitDetailCreateForm.setBenefit(benefit); createBenefitDetailModal.show()"
        ><i class="fa fal fa-plus"></i> Add Coverage...</a
    >
</form>
